import React from 'react';
import PropTypes from 'prop-types';

import { animation, colors } from '../../styles/constants';

// BoxShadow, TransformStyle and Translate3d are attempts at solving
// choppy svgs in Safari. Translate3d and BoxShadow are to enable hardware
// acceleration and transformStyle is from SO
// https://makandracards.com/makandra/31497-fixing-jerky-css3-animations
// https://stackoverflow.com/questions/11413758/choppy-svg-rendering-during-rotation-in-mobile-safari
const ImageCircle = ({ color, image, isInView, width, height, top, left }) => (
  <span
    xmlns="http://www.w3.org/2000/svg"
    href="http://www.w3.org/1999/xlink"
    xlinkHref="http://www.w3.org/1999/xlink"
    style={{
      borderRadius: '100%',
      backgroundColor: color,
      position: 'absolute',
      transitionProperty: 'transform, opacity',
      transitionDuration: ` ${animation.introCircle}ms`,
      transitionTimingFunction: 'ease-in-out',
      transformOrigin: 'center left',
      transform: `translateZ(0.1px) rotate(${(isInView ? 0 : 1) * -180}deg)`,
      opacity: top && left && width && height && isInView >= 0 ? 1 : 0,
      width: `${width}px`,
      height: `${height}px`,
      top,
      left,
      backgroundImage: `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '100% 75%'
    }}
  />
);

ImageCircle.propTypes = {
  color: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isInView: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

ImageCircle.defaultProps = {
  color: colors.cyan
};

export default ImageCircle;
